import { IdentityClient } from '@nvision/identity-client';
import { AuthService, STORAGE_KEYS, services } from '@nvision/identity-core';

import { ENV_VARS } from '@/env';

import { OIDC_AUTH_ROUTES } from '../routes';

export const initIdentityAuth = () => {
  // TODO: verify if still needed
  const isKeyExists = localStorage.getItem(STORAGE_KEYS.isProviderDisabled) !== null;
  if (isKeyExists) {
    return;
  }
  services.auth.enableOIDCProvider();
};

initIdentityAuth();

export const authService = new AuthService({
  authority: ENV_VARS.REACT_APP_OIDC_AUTHORITY ?? '',
  client_id: ENV_VARS.REACT_APP_OIDC_CLIENT_ID ?? '',
  permissions: ['external', 'internal'],
  // post_logout_redirect_uri: `${window.location.origin}/auth/logout-callback`,
  redirect_uri: `${window.location.origin}${OIDC_AUTH_ROUTES.OIDC_AUTH_CALLBACK}`,
  scope: ENV_VARS.REACT_APP_OIDC_SCOPES,
  silent_redirect_uri: `${window.location.origin}${OIDC_AUTH_ROUTES.OIDC_AUTH_CALLBACK}`,
});

export const identityClient = new IdentityClient({ authService });
